import { Component, computed, signal, effect, output } from '@angular/core';
import { SignupV2Service } from '../../signup-v2.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ArrayOptionsItem } from '../../../../shared/types/account.types';

@Component({
  selector: 'app-availability-step',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './availability-step.component.html',
  styleUrl: './availability-step.component.scss'
})
export class AvailabilityStepComponent {

  // Output para comunicarse con el componente padre
  stepCompleted = output<void>();

  constructor(public svc: SignupV2Service) {
    // reset window when day changes
    this.svc.availabilityForm.get('day')?.valueChanges.subscribe(() => {
      this.svc.availabilityForm.get('window')?.setValue(null);
      this.setupWindows();
    });

    effect(() => {
      const opts = this.days();
      const dayControl = this.svc.availabilityForm.get('day');
      if (opts.length) {
        if (!dayControl?.value)
          dayControl?.setValue(opts[0].id);
        else
          this.setupWindows();
      }
    });
  }

  days = computed(() => this.svc.getDeliveryOptions());

  windows = signal<ArrayOptionsItem[]>([]);

  private setupWindows() {
    const dayId = this.svc.availabilityForm.get('day')?.value;
    if (!dayId) { this.windows.set([]); return; }
    const day = this.svc.getDeliveryOptions().find(d => d.id === dayId);
    const times = day?.timeSet || [];
    this.windows.set(times);
    if (times.length) this.svc.availabilityForm.get('window')?.setValue(times[0].id);
  }

  async onNext() {
    if (!this.svc.canProceed('availability')) return;
    const isCompleted = await this.svc.markCompleted('availability');
    if (isCompleted) {
      this.stepCompleted.emit();
    }
  }
}
